<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Honoraires </div>
        <div class="modal-body">
            <div class="type-choice" *ngIf="infosModeJuxta">
                <p>Type de facture : </p>
                <frg-form-input id="typeFacture" type="ngSelect" [formGroup]="formGroup"
                    [control]="formGroup.get('typeFacture')" [selectValue]="typesList" ></frg-form-input>
            </div>
            <div class="recap-honoraires">
                <p>Date des soins :<span> {{ dateSoins | date }} </span></p>
                <p>Acte :<span> {{ actes }} </span></p>
                <p>Total de la facture :<span> {{ totalPrice }} </span></p>
            </div>
            <div class="elements-container">
                <!-- <div class="left-container">
                    <p class="title-side">Éléments de la FSE</p>
                    <div class="prices">
                        <p>Total de la facture :<span> {{ totalPrice }} </span></p>
                        <p>Règlement assuré :<span> 0,00 </span></p>
                        <p>Tiers payant AMO :<span> 0,00 </span></p>
                        <p>Tiers payant AMC :<span> 0,00 </span></p>
                    </div>
                    <div class="button-left">
                        <frg-button [type]="'button'">Honoraires dus par le patient</frg-button>
                        <frg-button [type]="'button'">Autres régularisations</frg-button>
                        <p>0,00</p>
                    </div>
                </div> -->
                <div class="right-container">
                    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                        <div>
                            <p class="title-side">Choix du paiement</p>
                            <div class="type-choice">
                                <p>Paiement Assuré : {{ modePaiement }}</p>
                                <frg-form-input id="actes" type="ngSelect" [formGroup]="formGroup"
                                    [control]="formGroup.get('actes')" [selectValue]="actesList"></frg-form-input>
                            </div>
                            <div class="payment-choice-buttons">
                                <frg-button [type]="'button'" (click)="switchModePaiement('Espèce')">ESP</frg-button>
                                <frg-button [type]="'button'" (click)="switchModePaiement('Chèque')">CHQ</frg-button>
                                <frg-button [type]="'button'" (click)="switchModePaiement('Carte Bancaire')">CB
                                </frg-button>
                                <frg-button [type]="'button'">MIXTE</frg-button>
                            </div>
                            <div class="tiers-payant">
                                <!-- <p>Tiers Payant <span>0,00</span></p> -->
                            </div>
                        </div>
                        <div class="type-choice">
                            <p>Type d'honoraires : </p>
                            <frg-form-input id="honoraires" type="ngSelect" [formGroup]="formGroup"
                                [control]="formGroup.get('honoraires')" [selectValue]="honorairesList"></frg-form-input>
                            <!-- <frg-form-input id="print" label="Impression de la feuille de soins" type="checkbox"
                                [formGroup]="formGroup" [control]="formGroup.get('print')" [isCheckLabelAlign]="true">
                            </frg-form-input> -->
                        </div>
                        <div class="buttons-wrapper">
                            <frg-button [type]="'button'" [backgroundColor]="'var(--darkest-primary)'"
                                (activated)="closeHonorairesModal()">Annuler</frg-button>
                            <frg-button [type]="'button'" (activated)="onSubmit()">Sélectionner
                            </frg-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>